<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div class="login-container">
    <el-card class="login-card" :body-style="{ padding: '40px' }">
      <template #header>
        <h2 class="login-title">管理后台登录</h2>
      </template>
      <el-form
        ref="formRef"
        :model="form"
        :rules="rules"
        label-width="0"
        @keyup.enter="login"
      >
        <el-form-item prop="userId">
          <el-input
            v-model="form.userId"
            placeholder="用户名"
            :prefix-icon="User"
            size="large"
          />
        </el-form-item>
        <el-form-item prop="password">
          <el-input
            v-model="form.password"
            type="password"
            placeholder="密码"
            :prefix-icon="Lock"
            size="large"
            show-password
          />
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            size="large"
            @click="login"
            style="width: 100%"
          >
            登录
          </el-button>
        </el-form-item>
      </el-form>
    </el-card>
    <div class="icp-footer"><a href="https://beian.miit.gov.cn/" target="_blank">辽ICP备2026007340号-1</a></div>
  </div>
</template>

<script setup>
import { ref, reactive } from 'vue'
import { ElMessage } from 'element-plus'
import { User, Lock } from '@element-plus/icons-vue'
import { useUserStore } from '@/stores/admin/userStore'
import { useRouter} from 'vue-router'

const userStore = useUserStore()
const router = useRouter()

const formRef = ref()
const form = reactive({
  userId: '',
  password: ''
})

const rules = {
  userId: [{ required: true, message: '请输入用户名', trigger: 'blur' }],
  password: [{ required: true, message: '请输入密码', trigger: 'blur' }]
}

const login = async () => {
  if (!formRef.value) return
  await formRef.value.validate(async (valid) => {
    if (!valid) return
    await userStore.login(form)
    ElMessage.success('登录成功!')
    router.push('/admin')
  })
}
</script>

<style scoped>
.login-container {
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  position: relative;
  flex-direction: column;
}
.login-card {
  width: 450px;
  border-radius: 8px;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.2);
}
.login-title {
  text-align: center;
  margin: 0;
  color: #333;
  font-size: 24px;
}
.login-tip {
  text-align: center;
  font-size: 13px;
  color: #999;
  margin-top: 20px;
}

.icp-footer {
  position: absolute;
  bottom: 16px;
  left: 0;
  right: 0;
  text-align: center;
}

.icp-footer a{
  font-size: 12px;
  color: #BFCBD9;
}

</style>